export const BASE_DASHBOARD_PATH = '/dashboard';

export const OVERVIEW_DASHBOARD_PATH = `${BASE_DASHBOARD_PATH}/overview`;
export const PERFORMANCE_DASHBOARD_PATH = `${BASE_DASHBOARD_PATH}/performance`;
